import { GetPlayerProfileResponse } from "services/players";

export const getHeroPlayerProps = (data: GetPlayerProfileResponse) => ({
    isManager: data.isManager,
    isEsports: data.team === 'esports',
    isEdsTeam: data.isEdsTeam,
    isAcademyTeam: data.isAcademyTeam,
    firstName: data.firstName,
    lastName: data.lastName,
    number: data.shirtNumber,
    country: data.country,
    flagUri: data.flagUri,
    position: data.position,
    dateOfBirth: data.dateOfBirth,
    halfBodyImageUri: data.halfBodyImageUri,
    isWomensTeam: data.isWomensTeam,
    mobileBackgroundImageUri: data.playerHeroMobileImage || undefined,
    desktopBackgroundImageUri: data.playerHeroDesktopImage || undefined,
});